<template lang="html">
  <div class="developer-wrapper">
    <!-- <button style="position:absolute;left:10px;top:10px;width:80px;height:20px;" @click="onHome">
      Home
    </button> -->
    <iframe
      id="myFrame"
      src=""
      scrolling="no"
      style="width:100%;height:700px;"
      frameborder="0"
    >
    </iframe>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data: function () {
    return {
      langData: {},
    }
  },
  created: function () {
  },
  mounted: function () {
    // this.getRemoteIP();
    const myframe = document.getElementById('myFrame');
    this.getRemoteIP(() => {
      const ip = window.remoteIP;
      console.log(`remote window.remoteIP = ${window.remoteIP}`);
      myframe.src = `http://${ip}:18322`;
    });
  },
  methods: {
    onHome() {
      if (window.parent.GlobalUtil) {
        window.parent.GlobalUtil.socketCom.close();
      }
      this.$router.push({ name: 'home' });
    },
    getRemoteIP(callback) {
      const url = 'https://update.ufactory.cc/releases/xarm/ip.json';
      axios.get(url).then((response) => {
        console.log(response.data.ip)
        const ip = response.data.ip;
        window.remoteIP = ip;
        if (callback) {
          callback();
        }
        // const myframe = document.getElementById('myFrame');
        // myframe.src = `http://${ip}:18322`;
      }, () => {
      });
    },
  }
}
</script>

<style scoped>
.contain-wrapper {
  width:100%;
  height: 100%;
}
.tip {
  color: #555;
  font-size: 16px;
  text-align: center;
  padding: 15px 0;
}
.lead-img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/remoteXarm.vue